import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=1cb1f3be&scoped=true&"
import script from "./add-or-update.vue?vue&type=script&lang=js&"
export * from "./add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./add-or-update.vue?vue&type=style&index=0&id=1cb1f3be&prod&lang=scss&"
import style1 from "./add-or-update.vue?vue&type=style&index=1&id=1cb1f3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb1f3be",
  null
  
)

export default component.exports